import React, { useContext, useEffect, useState } from "react";
import ContactForm from "./ContactForm";
import { Mail, Phone, MessageCircle, Sparkles } from "lucide-react";
import ProductCard from "../Containers/ProductCard";
import Fade from "react-reveal/Fade";
import { ProductContext } from "../../Context/products_context";
import { useMediaQuery } from "react-responsive";
import PropTypes from "prop-types";

const contactInfo = [
  {
    id: 1,
    title: "Email Us",
    href: "mailto:Marketplace@getbrand.gold",
    icon: Mail,
    text: "Marketplace@getbrand.gold",
    description: "Send us an email anytime",
  },
  {
    id: 2,
    title: "Call Us",
    href: "tel:+919581430505",
    icon: Phone,
    text: "+91 958 143 0505",
    description: "Mon-Fri from 9am to 6pm",
  },
];

const ContactArea = (props) => {
  ContactArea.propTypes = {
    contactclass: PropTypes.any,
  };

  const productss = useContext(ProductContext);
  const [loading, setLoading] = useState(true);
  const isTablet = useMediaQuery({
    query: "(max-width: 1280px)",
  });

  useEffect(() => {
    if (productss && productss.length > 0) {
      setLoading(false);
    }
  }, [productss]);

  return (
    <section
      className={`py-16 md:py-24 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 ${props.contactclass}`}
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        {/* Header Section */}
        <div className="text-center mb-12 md:mb-16">
          <Fade bottom>
            <div className="inline-flex items-center gap-2 px-6 py-2 bg-gradient-to-r from-[#fcdb6a] to-[#b99653] rounded-full mb-6 shadow-md">
              <MessageCircle className="w-4 h-4 text-[#101c4c]" />
              <span className="text-sm font-bold text-[#101c4c] uppercase tracking-wide">
                Contact Us
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              <span className="text-[#101c4c]">Let's</span>{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#b99653] to-[#fcdb6a]">
                Talk
              </span>
            </h2>
            <p className="text-gray-600 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
              Have a question or want to work together? We'd love to hear from
              you.
            </p>
          </Fade>
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
          {/* Contact Form - Left Side */}
          <div className={`${isTablet ? "xl:col-span-3" : "xl:col-span-2"}`}>
            <Fade left>
              <div className="bg-white rounded-3xl shadow-xl border border-blue-100 overflow-hidden">
                {/* Form Header */}
                <div className="bg-gradient-to-r from-[#101c4c] to-[#1a2a5e] px-8 py-6">
                  <h3 className="text-2xl font-bold text-white mb-1">
                    Get In Touch
                  </h3>
                  <p className="text-gray-300 text-sm">
                    Terces Solutions Private Limited
                  </p>
                </div>

                {/* Form Content */}
                <div className="p-8">
                  <ContactForm />
                </div>
              </div>
            </Fade>
          </div>

          {/* Right Side - Contact Info & Product */}
          {!isTablet && (
            <div className="xl:col-span-1 space-y-6">
              <Fade right>
                {/* Contact Information Cards */}
                <div className="space-y-4">
                  {contactInfo.map((info) => {
                    const IconComponent = info.icon;
                    return (
                      <a
                        key={info.id}
                        href={info.href}
                        className="block bg-white rounded-2xl shadow-lg border border-gray-200 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden group"
                      >
                        <div className="p-6">
                          <div className="flex items-start gap-4">
                            <div className="p-3 bg-gradient-to-br from-[#fcdb6a] to-[#b99653] rounded-xl shadow-md group-hover:scale-110 transition-transform duration-300">
                              <IconComponent className="w-6 h-6 text-[#101c4c]" />
                            </div>
                            <div className="flex-1">
                              <h4 className="font-bold text-[#101c4c] text-lg mb-1">
                                {info.title}
                              </h4>
                              <p className="text-sm text-gray-500 mb-2">
                                {info.description}
                              </p>
                              <p className="text-[#b99653] font-semibold group-hover:underline">
                                {info.text}
                              </p>
                            </div>
                          </div>
                        </div>
                      </a>
                    );
                  })}
                </div>

                {/* Featured Product or Gold Loader */}
                <div>
                  {loading ? (
                    <GoldLoader />
                  ) : (
                    <>
                      {productss && productss.length > 0 && (
                        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
                          <div className="bg-gradient-to-r from-[#fcdb6a] to-[#b99653] px-6 py-4">
                            <div className="flex items-center gap-2">
                              <Sparkles className="w-5 h-5 text-[#101c4c]" />
                              <h4 className="font-bold text-[#101c4c] text-lg">
                                Featured Domain
                              </h4>
                            </div>
                          </div>
                          <div className="p-4">
                            {productss.slice(0, 1).map((product) => (
                              <ProductCard
                                key={product._id}
                                product={product}
                              />
                            ))}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </Fade>
            </div>
          )}
        </div>

        {/* Bottom Info Section */}
        <Fade bottom>
          <div className="mt-16 bg-gradient-to-br from-[#101c4c] via-[#1a2a5e] to-[#0d1636] rounded-3xl p-10 md:p-12 shadow-2xl text-white">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-center">
              <div>
                <div className="w-16 h-16 bg-gradient-to-br from-[#fcdb6a] to-[#b99653] rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <MessageCircle className="w-8 h-8 text-[#101c4c]" />
                </div>
                <h4 className="font-bold text-xl mb-2">Quick Response</h4>
                <p className="text-gray-300 text-base">
                  We typically respond within 24 hours
                </p>
              </div>
              <div>
                <div className="w-16 h-16 bg-gradient-to-br from-[#fcdb6a] to-[#b99653] rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <Phone className="w-8 h-8 text-[#101c4c]" />
                </div>
                <h4 className="font-bold text-xl mb-2">Expert Support</h4>
                <p className="text-gray-300 text-base">
                  Professional domain consultation
                </p>
              </div>
              <div>
                <div className="w-16 h-16 bg-gradient-to-br from-[#fcdb6a] to-[#b99653] rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <Sparkles className="w-8 h-8 text-[#101c4c]" />
                </div>
                <h4 className="font-bold text-xl mb-2">Premium Service</h4>
                <p className="text-gray-300 text-base">
                  Dedicated account management
                </p>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    </section>
  );
};

export default ContactArea;

function GoldLoader() {
  return (
    <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
      <div className="bg-gradient-to-r from-[#fcdb6a] to-[#b99653] px-6 py-4">
        <div className="flex items-center gap-2">
          <Sparkles className="w-5 h-5 text-[#101c4c]" />
          <h4 className="font-bold text-[#101c4c] text-lg">.Gold Domains</h4>
        </div>
      </div>
      <div className="p-6">
        <p className="text-[#101c4c] font-bold text-lg mb-4">Perfect for:</p>
        <ul className="space-y-3">
          {[
            { emoji: "💍", text: "Jewellery Brands" },
            { emoji: "📈", text: "Gold Traders" },
            { emoji: "🌐", text: "Gold Importers" },
            { emoji: "🚢", text: "Gold Exporters" },
            { emoji: "🧪", text: "Gold Purifiers" },
            { emoji: "⛏️", text: "Gold Miners" },
            { emoji: "💼", text: "Domain Investors" },
          ].map((item, index) => (
            <li key={index} className="flex items-center gap-3 text-gray-700">
              <span className="text-xl">{item.emoji}</span>
              <span className="font-semibold">{item.text}</span>
            </li>
          ))}
        </ul>
        <div className="mt-6 pt-6 border-t border-gray-200">
          <a
            href="/domains"
            className="flex items-center justify-center gap-2 w-full px-6 py-3 bg-gradient-to-r from-[#b99653] to-[#fcdb6a] text-white rounded-xl font-bold shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
          >
            <Sparkles className="w-5 h-5" />
            <span>Browse Domains</span>
          </a>
        </div>
      </div>
    </div>
  );
}
